module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.4.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.10.0.0.box.374.616.196.74.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.10.0.0.box.374.616.196.74.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.5.0"
    }
  }), _vm._v("Preface ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.10.1.0.box.180.870.1343.1683.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.0.box.180.870.1342.324.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.7.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR8.w.0.0.0"
    }
  }), _vm._v("ever-growing ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("mass ")]), _c('a', {
    attrs: {
      "id": "GBS.PR9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.0.0"
    }
  }), _vm._v("of literature about New Orleans treats mainly the developments along the Mississippi bend which Bienville admired as \"the finest crescent of the river.\" Here the French established and the Spanish embellished the capital of the Louisiana Colony. Here is the Vieux Carré, the old square, favored by tourist and native alike, perennial subject for photographer, artist, and writer.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.1.box.181.1203.1341.261.q.60"
    }
  }, [_vm._v("Contributors to the local historical scene have almost uniformly neglected another river crescent whose tip took shape only nine miles above the Vieux Carré. Always geographically strategic to the sprawling urbanized area and long agriculturally productive, it now cradles the most densely populated suburb in the state.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.2.box.181.1475.1342.318.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.2.0"
    }
  }), _vm._v("The explorer La Salle noticed this river bend when he descended and ascended the Mississippi in the spring of 1682. Before the end of the seventeenth century Iberville and Bienville more closely explored it, both front and rear, when they reconnoitred not only the river coast but also the shoreline of Lake Pontchartrain along what would become known as the east bank of Jefferson Parish.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.3.box.180.1804.1342.311.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.3.0"
    }
  }), _vm._v("Very early in the eighteenth century, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cannes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Brûlées ")]), _vm._v("became East Jefferson's oldest place name, indicating the cleared tract eighteen miles above New Orleans along the left descending bank of the river. Between "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cannes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Brûlées")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("(literally, \"burnt canes\") and the eight-mile stretch of land owned by Bienville above the Vieux Carré, was the second river crescent, which pioneers named "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Les ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chapitoulas. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.4.box.182.2129.1340.366.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.4.0"
    }
  }), _vm._v("Almost simultaneously with the founding of New Orleans in 1718, John Law's Company of the West began granting land at both "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cannes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Brûlées")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("and "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chapitoulas ")]), _vm._v("to European investors and to a handful of Canadians struggling to survive along the Gulf Coast. Settlers quickly exploited the original concessions, some of which ran from river to lake, helped feed the city, provided it with critical building materials, and enhanced its value as a port.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR9.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.10.1.5.box.274.2507.1248.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR9.w.1.5.0"
    }
  }), _vm._v("Some 285,000 persons live within the old Chapitoulas crescent"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.11.1.0.box.180.286.1348.318.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.0.0"
    }
  }), _vm._v("\nand the neighboring cities of Harahan and Kenner. Of these about 170,000 reside in Metairie, now among the most populous and prosperous unincorporated communities in the United States. It is, therefore, unfortunate that superficial attention by historians leaves most Metairieites with the impression that East Jefferson has practically no significant history.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.11.1.0.box.178.286.1356.2177.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.1.1.box.178.615.1350.484.q.60"
    }
  }, [_vm._v("In our time, the boundaries of Metairie are Kenner on the west and New Orleans on the east between the Airline Highway and Lake Pontchartrain. The Chapitoulas of the old maps would extend today from the lower Kenner city limits to the Protection Levee or Monticello Avenue separating Orleans from Jefferson Parish on the east bank; its northern boundary would be the Airline Highway, its southern the river. Together with Harahan and Kenner, the whole area comprises approximately 32,000 acres, the entire east bank of Jefferson Parish, which strides the Mississippi, Louisiana's first thoroughfare.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.1.2.box.180.1111.1350.414.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.2.0"
    }
  }), _vm._v("Our story opens with the great river and its distributary known as the Metairie Bayou, in prehistoric times a navigable stream from Kenner to Chef Menteur. The first to ply the bayou and to traverse and even live on the ridge formed on either side were Indians. The second chapter of this study touches on the tribes familiar to the French discoverers, explorers and missionaries. The Indian tribal names perdure in Louisiana folklore and in the nomenclature of New Orleans and Metairie streets.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.1.3.box.181.1546.1352.806.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.3.0"
    }
  }), _vm._v("Friendly relations with the Indians who used the Metairie distributary helped three Chauvin brothers, natives of Canada, along with Dubreuil and Chartier de Baulne, immigrants from France, to exploit The Chapitoulas. These men and their ventures form the subject of the third chapter. Their plantations, although mainly worked by imported black slaves, attracted families from Europe and other parts of the Louisiana Colony. The Company of the West and its successor, the Company of the Indies, were obliged by charter to provide the services of Catholic priests to the settlers and slaves, both black and Indian. The first of the permanently assigned missionaries were the Capuchins of Champagne, France. Their superior's struggles with some Chapitoulas leaders, as well as the abortive attempts to establish a church parish in what is now East Jefferson, between New Orleans and the German Coast upriver, are the topics discussed in the fourth essay of this book.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR10.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.11.1.4.box.186.2364.1348.99.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR10.w.1.4.0"
    }
  }), _vm._v("The next essay relates some of the activities at The Chapitoulas during the waning years of Company control in Louisiana and during"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.12.1.0.box.228.304.1340.379.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.0.0"
    }
  }), _vm._v("\nthe decades which followed, when Louisiana was a French crown colony. The sixth chapter recalls the end of French domination, but only after recounting some of the deeds of the Chapitoulas inhabitant who led an unsuccessful revolt against legitimate Spanish authority. Too long revered as one of the patriots of French Louisiana, he is now viewed as an overly zealous confiscator of the valuable Jesuit plantation.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.12.1.0.box.228.304.1344.2177.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.1.box.230.693.1337.478.q.60"
    }
  }, [_vm._v("The confiscation of the properties of this revolutionary, Nicolas de La Frenière, Jr., introduces the reader to the seventh chapter, which finds the Capuchins owning most of \"Old\" Metairie, called in Spanish an "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("alquería")]), _vm._v(","), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("a grange, and sometimes in French, a "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("vacherie")]), _vm._v(","), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }), _vm._v("dairy land. The monks perforce gave up the place, not returning it directly to the King as legend claims, but selling to Don Andrés Almonester y Roxas. He in turn quickly disposed of his Metairie property, after offering it and its dairy revenues as an endowment to the Charity Hospital of New Orleans.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.2.box.231.1189.1338.535.q.60"
    }
  }, [_vm._v("By the turn of the nineteenth century, Louisiana, and therefore Metairie, became American territory. In 1825, Jefferson Parish, originally to be called Tchoupitoulas Parish, emerged as a civil jurisdiction carved out of Orleans. The eighth and ninth chapters cover these transitions, as well as the geographical shrinking of East Jefferson. Annexation by New Orleans of the various faubourgs or suburbs was the principal cause of this reduction, beginning with the Faubourg Nuns, directly above the Jesuits' plantation. Faubourg Nuns thus gave Jefferson its first eastern boundary. The last suburb to be assimilated by New Orleans was the city of Carrollton, the subject of the tenth essay.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.3.box.233.1736.1338.471.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.3.0"
    }
  }), _vm._v("By the 1830s, surveyors were at work in Metairie sections long identified in conveyance records as Bath, Metairieville, and Metairie Burg. Together the neighborhoods comprise \"Old\" Metairie, and Chapter Eleven outlines the emergence of this community. The following chapter narrates the attempt to provide religious services to residents of the Metairie Ridge and those living on or near the shore of Lake Pontchartrain at New Orleans's West End and Jefferson's East End. Here are the beginnings of St. Francis Xavier Parish whose fiftieth anniversary this book commemorates.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR11.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.12.1.4.box.234.2221.1338.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR11.w.1.4.0"
    }
  }), _vm._v("The next four essays focus on the history of the church parish, with special emphasis on its pastors, pioneer parishioners, and the Religious Sisters of Mercy who have staffed the parish school. Some charter parishioners are still living; their sharply etched memories of the Metairie of another era are related in the seventeenth chapter.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR12.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.13.1.0.box.130.271.1340.317.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR12.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.1.0.box.130.271.1340.317.q.60"
    }
  }, [_vm._v("The evolution of modern-day Metairie is the subject of Chapter Eighteen. The last two essays outline the beginnings of other church parishes established along or close to the Metairie Ridge, described of old as \"a tongue of land to lend pasturage. . . .\" The people who have lived on and worked this land, as well as the priests who have ministered to them, deserve to have the story of their faith community told.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.13.3.0.box.124.680.1339.429.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR12.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.13.3.0.box.124.680.1339.429.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR12.w.2.0.0"
    }
  }), _vm._v("By autumn of 1977, this book, first published in December, 1973, was out of print. Since the volume was still in demand, especially with the establishment of the Jefferson Historical Society of Louisiana which prompted a resurgence of interest in the lore of the civil parish, the publisher and author felt that a second printing was timely. This version is substantially the same as the first. Changes include updated statistics, minor corrections, and information on the latest addition to the church parishes which make up the East Jefferson Deanery.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.13.4.0.box.122.1142.1337.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR12.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.13.4.0.box.122.1142.306.43.q.80"
    }
  }, [_vm._v("August 15, 1978")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR12.w.4.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "right"
    },
    attrs: {
      "id": "para.13.4.1.box.1033.1145.426.44.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR12.w.2.1.0"
    }
  }), _vm._v("Msgr. Henry C. Bezou")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR13.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR13.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR13.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.14.0.0.box.371.542.483.72.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR13.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "font-variant": "small-caps",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.14.0.0.box.371.542.483.72.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Acknowledgments ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.1.0.box.177.793.1354.1687.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR13.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.0.box.180.793.1343.102.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("family ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("families ")]), _vm._v("comprising St. Francis Xavier Parish made possible the preparation and production of this volume.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR13.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.1.box.177.904.1349.483.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR13.w.1.1.0"
    }
  }), _vm._v("From the outset, the author received consistent support from the Parish Council, headed in 1973 by Mr. J. Bres Eustis, and from the Golden Jubilee Committee, chaired by Mr. Jerome L. Tujague. During meetings and conferences, over coffee cups and at supper tables, on the occasion of casual home visits and chats on Metairie street corners, after sick calls and census taking, through taped interviews in the rectory and telephone conversations (non-tapped), the author gathered and unraveled over a period of three years the fascinating but sometimes elusive strands of Metairie Ridge lore.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR13.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.2.box.180.1400.1351.1080.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR13.w.1.2.0"
    }
  }), _vm._v("Most informants will find their names interspersed among these pages, but the following parishioners and neighbors undertook specific tasks and merit special thanks: Mrs. Gayle Singer Sarrat, who blue-penciled the preliminary draft with the authority of a fourth generation Metairieite and the sure touch of a serious student of syntax; Mrs. A. T. Mora, parish secretary and one of the few persons able to decipher the author's handwriting or interpret his typing; Miss Mary Laiche, whose interest in the project equalled her determination to meet deadlines; Father Thomas McCormick, critical reader of early versions; Sister M. Angela, R.S.M., a fount of information about parochial school activities; Miss Bertha Rodrigue, Mrs. Mimi O'Connor Denis, and Deacon (now Father) Ken Hedrick who, with seminarian Keith Reese, did copious photocopying, note-taking, and dictating from library indices, microfilmed newspaper files, and notarial archives; Mr. Harold N. Hickey, geological consultant; Mrs. Grace Ward, advisor on the flora of the area; Mr. James A. Greene, Sr., who shared generously his research and original maps; Mr. G. Stanley Beck, who volunteered his skilled services as draftsman; Mr. John C. Werner, photographer for Darrell De Moss, who reproduced nearly all of the illustrations; and countless others in the church parish, including"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR14.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.15.1.0.box.145.319.1343.143.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.0.0"
    }
  }), _vm._v("\nFather Bernard A. Grehan, associate pastor, who listened and suggested, questioned and challenged, during the nine months the chapters evolved.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.15.1.0.box.136.319.1352.2151.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR14.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.1.box.140.485.1346.1184.q.60"
    }
  }, [_vm._v("Others also cheerfully helped during this period of gestation. Chief among them was Mrs. Alice Forsyth, archivist of St. Louis Cathedral, who located, photocopied, and annotated vital records of immense value and, further, directed the writer to documents in collections with which she was more familiar. Father Robert Stahl, S.M., librarian at Notre Dame Seminary, rendered his customarily competent and courteous assistance at all hours, as did Sister Marguerite Brou, O.P., of the archdiocesan archives. Mr. James F. Bezou, Dr. Theodore L. L. Soniat, and Miss Claire Weitkam loaned rare books for extended periods of time. The late Fernand C. Gandolfo, Jr., opened his surveyor's files on Metairie and shared the notes of his deceased predecessor, Frank H. Waddill. Another helpful surveyor of the area was Mr. Samuel Landry. Mr. Carlo J. Taravella, supervisor of the Mortgage and Conveyance Department of the Clerk of the 24th Judicial District Court, provided photocopies of nineteenth century Jefferson Parish records through the intermediary of Mr. Harold J. Calder. At the state level, Secretary of State Wade O. Martin, Jr., and Mr. Ory G. Poret, Deputy Register of the State Land Office, responded readily to requests for documentation. Confreres of various churches, both those which were in Jefferson Parish at the beginning and those now part of the deanery of East Jefferson, provided archival materials which are the warp and woof of this history.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR14.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.2.box.136.1680.1345.790.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR14.w.1.2.0"
    }
  }), _vm._v("Among others, grateful mention must be made of the staffs at the Louisiana State Museum, the Historic New Orleans Collection, the Howard Tilton Memorial Library, Tulane University, Loyola University of the South, St. Joseph Seminary, St. Benedict, and the New Orleans and Jefferson Parish public libraries. Their professional aid was reinforced by the late Mr. René J. Le Gardeur, Jr., who read the first ten chapters literally on the eve of his death; by Mr. Samuel Wilson, Jr., who read the completed manuscript, made corrections, offered suggestions, and shared his numerous published contributions to local history; by Mr. Leonard V. Huber, good neighbor and gracious host; and by each of my three predecessors as pastor of St. Francis Xavier Church. Even Father F. X. Rombouts, when approaching 90 years of age, was able to share his reminiscences and jot pertinent notes on the formative years of the parish. To all, the author offers a hearty \""), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bien ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("merci.")]), _vm._v("\"")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-top": "5em"
    },
    attrs: {
      "id": "block.16.0.0.box.556.846.567.190.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "142%",
      "text-align": "center",
      "font-weight": "bold",
      "margin-top": "1em",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.16.0.0.box.622.846.430.106.q.80"
    }
  }, [_vm._v("Metairie")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.16.0.1.box.556.984.567.52.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  }), _vm._v("A Tongue of Land to Pasture")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA3.w.0.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b6fb4fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0004.vue
// module id = 57
// module chunks = 0